import React from 'react';
import Portfolio from '../components/Portfolio';
import Contact from '../components/Contact';

function PortfolioPage() {
  return (
    <div className="page-transition pt-20">
      {/* Page Header */}
      <section className="py-20 bg-gradient-to-br from-blue-500 to-indigo-600 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-black mb-6">Our Portfolio</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            Explore our successful projects and see how we've helped businesses grow
          </p>
        </div>
      </section>
      
      <Portfolio />
      <Contact />
    </div>
  );
}

export default PortfolioPage;